import { BankDetails as DefaultBankDetails } from "src/components/feature/Onboarding";

const BankDetails = () => {
  return <DefaultBankDetails />;
};

export default BankDetails;
